import React, {useEffect} from 'react';
import './AlbumList.css';
import {Link} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {albumSelector, getAllAlbum} from '../../../features/album/albumSlice';

function AlbumList() {
  const {data, status, error} = useSelector(albumSelector);
  const dispatch = useDispatch();

  useEffect(() => dispatch(getAllAlbum()), [dispatch]);
  return (
    <div className="album">
      <div className="release__grid">
        {status === 'loading' ? (
          <h2>Loading...</h2>
        ) : error ? (
          <h2>{error}</h2>
        ) : (
          data?.map((album) => {
            return (
              <>
                <article className="album-item container" key={album._id}>
                  <Link
                    to={`/product/${album._id}`}
                    title={album.title}
                    className="video__link"
                  >
                    <img
                      src={album.imageUrl}
                      alt={album.title}
                      className="img-responsive video-thumb"
                    />

                    <div className="album-overlay">
                      <div className="album-info">
                        <h2 className="album-title">{album.title}</h2>
                        <p>{album.price} RWF</p>
                      </div>
                    </div>
                  </Link>
                </article>
              </>
            );
          })
        )}
      </div>
    </div>
  );
}

export default AlbumList;
